export default __webpack_public_path__ + "static/proxima-nova-800-cbf1a15948a94901cf65c72e303a9d04.woff2";